import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const LorryHireChallanDetailPage = lazy(() => import("@/pages/lorry-hire-challans.$id.page"));

export const Route = createFileRoute("/lorry-hire-challans/$id")({
  component: LorryHireChallanDetailPage,
});
